import styled from "@emotion/styled";
import { Box, Stack, useMediaQuery } from "@mui/material";
import { CanvasTuningTool } from "./CanvasTuningTool";
import { CanvasTilesTool } from "./CanvasTilesTool";
import EmailPreviewTool from "./EmailPreviewTool";
import CanvasRepeatTool from "./CanvasRepeatTool";
import PrintPreviewTool from "./PrintPreviewTool";
import ShareTool from "./ShareTool";
import ActionsTool from "./ActionsTool";
import CanvasControlsTool from "./CanvasControlsTool";
import LoadingBox from "../LoadingBox";
import CanvasRulersTool from "./CanvasRulersTool";

const AbsoluteContainer = styled(Box)(({ theme }) => ({
  position: "absolute",
  left: 0,
  bottom: 0,
  padding: theme.spacing(2, 0),
  width: "100%",
  zIndex: theme.zIndex.canvasTools,
}));

const StyledStack = styled(Stack)(({ theme }) => ({
  [theme.breakpoints.down('sm')]: {
    width: 0,
    right: '60px',
    position: 'absolute',
    bottom: '20px',
    flexDirection: 'column'
  }
}));

function CanvasTools() {
  return (
    <AbsoluteContainer>
      <LoadingBox>
        <StyledStack
          direction={'row'}
          gap={1}
          sx={{
            placeItems: 'center',
            flexWrap: 'wrap',
            justifyContent: 'center'
          }}
        >
          <CanvasTuningTool />
          <CanvasRulersTool />
          <CanvasTilesTool />
          <CanvasRepeatTool />
          <EmailPreviewTool />
          <PrintPreviewTool />
          <ShareTool />
          <CanvasControlsTool />
          <ActionsTool />
        </StyledStack>
      </LoadingBox>
    </AbsoluteContainer>
  );
}

export default CanvasTools;
